

























  import Vue from 'vue';

  export default Vue.extend({
    name: "TableEditWidget",
    props: {
      config: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        localConfig: this.config
      }
    }
});
